import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "backdrop"]

  toggle() {
    const isOpen = this.menuTarget.classList.contains("slide-in")

    if (!isOpen) {
      // メニューを開く
      this.menuTarget.classList.remove("hidden")
      this.backdropTarget.classList.remove("hidden")

      // 少し遅延させてからスライドインアニメーションを開始
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.menuTarget.classList.add("slide-in")
          this.backdropTarget.classList.add("show")
        })
      })

      this.enableBackdropClose()
    } else {
      // メニューを閉じる
      this.close()
    }
  }

  close() {
    if (!this.menuTarget.classList.contains("hidden")) {
      // スライドアウトアニメーション
      this.menuTarget.classList.remove("slide-in")
      this.backdropTarget.classList.remove("show")

      // アニメーション完了後に非表示にする
      setTimeout(() => {
        this.menuTarget.classList.add("hidden")
        this.backdropTarget.classList.add("hidden")
      }, 300) // CSSのtransition-durationと合わせる

      this.disableBackdropClose()
    }
  }

  enableBackdropClose() {
    // メニュー外をクリックしたら閉じる
    this.backdropHandler = (event) => {
      if (!this.element.contains(event.target) ||
          (event.target.tagName === 'A' && !event.target.closest('summary'))) {
        this.close()
      }
    }
    document.addEventListener("click", this.backdropHandler)
  }

  disableBackdropClose() {
    if (this.backdropHandler) {
      document.removeEventListener("click", this.backdropHandler)
      this.backdropHandler = null
    }
  }

  disconnect() {
    this.disableBackdropClose()
  }
}
